<script>
  import { toSrcsetString } from '@nrk/dh-basis-mediainfo/render-utils'

  export let bilde
</script>

<picture>
  {#each bilde.mediaInfo?.sources as { type, srcset }}
    <source
      {type}
      srcset={toSrcsetString(srcset)}
      sizes="114px"
      width={bilde.mediaInfo?.naturalDimensions?.width}
      height={bilde.mediaInfo?.naturalDimensions?.height}
    />
  {/each}
  <img alt="" />
</picture>
